import { useSearchParams } from "next/navigation";

import { useSelector } from "@/redux/hooks";
import { getUserAgent } from "@/redux/selectors/userAgent";

import GoogleAd from "@/components/GoogleAd";

const ProductsAd: React.FC<{
  className?: string;
  sizes?: Record<string, googletag.GeneralSize>;
  unit: string;
}> = ({ className, sizes, unit }) => {
  const searchParams = useSearchParams();
  const { isMobile, isIOS } = useSelector(getUserAgent);

  const category = searchParams?.get("category");
  const subcategory = searchParams?.get("category") || undefined;

  return (
    <GoogleAd
      targeting={{
        "brand-expression": "true",
        device: isMobile ? (isIOS ? "ios-app" : "android-app") : "web",
        "product-category": category || "home",
        "product-subcategory": subcategory,
      }}
      adPath={`/13212770/product/${unit}`}
      className={className}
      sizes={sizes}
    />
  );
};

export default ProductsAd;
